export var EFileSize;
(function (EFileSize) {
    EFileSize["micro"] = "77x77";
    EFileSize["small"] = "200x200";
    EFileSize["thumb"] = "1024x300";
    EFileSize["big"] = "960x640";
    EFileSize["large"] = "1264x770";
    EFileSize["huge"] = "1920x1080";
})(EFileSize || (EFileSize = {}));
export var EFileType;
(function (EFileType) {
    EFileType["video"] = "video";
    EFileType["doc"] = "document";
    EFileType["image"] = "image";
    EFileType["archive"] = "archive";
    EFileType["mobileVideo"] = "mobile-video";
})(EFileType || (EFileType = {}));
export var EFileExtension;
(function (EFileExtension) {
    EFileExtension["docx"] = "docx";
    EFileExtension["doc"] = "doc";
    EFileExtension["ppt"] = "ppt";
    EFileExtension["pptx"] = "pptx";
    EFileExtension["xlsx"] = "xlsx";
    EFileExtension["xls"] = "xls";
    EFileExtension["pdf"] = "pdf";
    EFileExtension["png"] = "png";
    EFileExtension["zip"] = "zip";
    EFileExtension["mp4"] = "mp4";
    EFileExtension["jpg"] = "jpg";
})(EFileExtension || (EFileExtension = {}));
export const docsExtensions = [
    EFileExtension.ppt,
    EFileExtension.doc,
    EFileExtension.xlsx,
    EFileExtension.xls,
    EFileExtension.pptx,
    EFileExtension.docx,
    EFileExtension.pdf,
    EFileExtension.zip,
];
export var EFileSubType;
(function (EFileSubType) {
    EFileSubType["youtube"] = "youtube";
})(EFileSubType || (EFileSubType = {}));
export const FILE_WITH_COPYRIGHT_PREFIX = '_wtrm';
